// import cache from "./catch";

function request({ url, data = null, method = "GET", headers = null, cacheKey, cacheTime }) {
  try {
    var controller = new AbortController();
    var signal = controller.signal;
  } catch (error) {
    
  }

  let options = {
    method: method,
    headers: {
      "X-Access-Channel": `ai_slide_generator`
    }
  }
  
  if (headers) {
    options.headers = Object.assign(options.headers, headers);
    if (headers['Content-Type'] && headers['Content-Type'].indexOf('application/x-www-form-urlencoded') != -1 && data) {
      let _data = "";
      Object.keys(data).forEach(element => {
        if (data[element] || data[element] == 0) {
          _data += `${element}=${data[element]}&`
        }
      })
      data = _data.slice(0, _data.length - 1);
    }
  }
  if (data) {
    if (typeof(data) == "string") {
      options.body = data;
    } else {
      options.body = JSON.stringify(data);
    }
  }
  if (signal) {
    options.signal = signal;
  }

  const timeoutPromise = () => {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(new Response("timeout", { status: 504, statusText: "timeout" }));
          if (controller) controller.abort();
        }, 60000)
    })
  }

  return Promise.race([timeoutPromise(), fetch(url, options).then(response => response.json())])
    .then(data => {
      if (data.success == true || data.ok === 0 || data.code == 0) {
        if (cacheKey) {
          if (cacheTime) {
            // cache.put(cacheKey, data.data, cacheTime);
          } else {
            // cache.put(cacheKey, data.data);
          }
        }
        if (data.message || data.message == 0) window.g_message = data.message;
        return Promise.resolve(data.data);
      } else if (data && (data.image || data.result)) {
        if (cacheKey) {
          if (cacheTime) {
            // cache.put(cacheKey, data, cacheTime);
          } else {
            // cache.put(cacheKey, data);
          }
        }
        return Promise.resolve(data);
      } else {
        if (data.statusText == "timeout") {
          return Promise.reject("The system is busy, please try again later");
        } else {
          return Promise.reject(data.message || data.msg && data || "failed, please check your network and try again");
        }
      }
    })
    .catch(error => {
      return Promise.reject(error);
    })
}

export default request;